import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { UserX, Send, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";

// Coach-side attendance log: every session this player was marked a no-show.
export const NoShowLog = ({ studentId }) => {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get(`/coach/players/${studentId}/no-shows`).then((r) => setRows(r.data.items || [])).catch(() => setRows([])); }, [studentId]);
  if (!rows) return null;
  return (
    <div className="card-surface p-5 sm:p-6" data-testid="player-no-show-log">
      <div className="label-mono mb-3 inline-flex items-center gap-2"><UserX className="w-3.5 h-3.5 text-[#FF4500]" /> ATTENDANCE · NO-SHOWS ({rows.length})</div>
      {rows.length === 0 ? (
        <div className="text-sm text-[#737373]" data-testid="no-show-empty">No no-shows recorded.</div>
      ) : (
        <ul className="divide-y divide-[#1F1F1F]">
          {rows.map((r) => (
            <li key={r.booking_id} className="py-2.5 flex flex-wrap items-center justify-between gap-2" data-testid={`no-show-row-${r.booking_id}`}>
              <div className="min-w-0">
                {r.offering_id ? <Link to={`/offerings/${r.offering_id}`} className="text-sm font-semibold hover:text-[#CCFF00]">{r.title}</Link> : <span className="text-sm font-semibold">{r.title}</span>}
                <div className="text-xs text-[#A3A3A3]">{r.when}</div>
              </div>
              <span className="text-[10px] uppercase tracking-wider font-bold text-[#FF4500] border border-[#FF4500]/50 px-2 py-0.5">No-show</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export const RequestAssessmentButton = ({ player, onDone }) => {
  const [busy, setBusy] = useState(false);
  const sent = player.assessment_requested_at;
  const send = async () => {
    setBusy(true);
    try {
      await api.post(`/coach/players/${player.id}/request-assessment`);
      toast.success(`${player.name} has been asked to book their assessment`);
      onDone && onDone();
    } catch (e) {
      toast.error(formatApiError(e?.response?.data?.detail) || "Couldn't send the request");
    } finally { setBusy(false); }
  };
  return (
    <button type="button" onClick={send} disabled={busy} data-testid="request-assessment-btn"
      className="px-4 py-2.5 text-xs inline-flex items-center gap-2 font-bold uppercase tracking-wider border border-[#FF9F1C] text-[#FF9F1C] hover:bg-[#FF9F1C]/10 disabled:opacity-50">
      {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Send className="w-3.5 h-3.5" />}
      {sent ? "Remind to book assessment" : "Request assessment"}
    </button>
  );
};
